import type * as sqlynx from "@ankoh/sqlynx-core";
import { historyField } from "@codemirror/commands";
import {
  EditorState as CMEditorState,
  Extension,
  StateEffect,
} from "@codemirror/state";
import { EditorView } from "@codemirror/view";

import { EditorState } from "pages/DevelopWorkspace/workspace.types";

import { UpdateSQLynxScript } from "../extensions/sqlynx_processor";

export function createInitialCMState(
  serialized: EditorState,
  extensions: Extension[]
): CMEditorState {
  try {
    return CMEditorState.fromJSON(
      serialized,
      { extensions },
      { history: historyField }
    );
  } catch {
    return CMEditorState.create({ extensions, doc: serialized?.doc ?? "" });
  }
}

export function setFocusAndScrollToHead(view: EditorView, head: number): void {
  view.focus();
  view.dispatch({
    effects: EditorView.scrollIntoView(head, { y: "center", x: "center" }),
  });
}

export function serializeViewState(
  view: EditorView,
  original: string | null
): EditorState {
  const json = view.state.toJSON({ history: historyField });
  return {
    doc: json.doc,
    selection: json.selection,
    history: json.history,
    original,
  };
}

export function syncSQLynxScript(
  view: EditorView,
  serialized: EditorState,
  sqlynxScript: sqlynx.SQLynxScript
): void {
  // reset and sync contents
  const totalLength = sqlynxScript.toString().length;
  if (totalLength > 0) {
    sqlynxScript.eraseTextRange(0, totalLength);
  }
  sqlynxScript.replaceText("");

  const { doc, selection } = serialized;
  sqlynxScript.replaceText(doc);
  const head = selection.ranges[0]?.head ?? 0;
  sqlynxScript.moveCursor(head);

  const effects: StateEffect<unknown>[] = [
    UpdateSQLynxScript.of({
      config: { showCompletionDetails: false },
      scriptKey: 2,
      targetScriptVersion: 1,
      targetScript: sqlynxScript,
      scriptBuffers: {
        scanned: null,
        parsed: null,
        analyzed: null,
        destroy: () => {},
      },
      scriptCursor: null,
      focusedColumnRefs: null,
      focusedTableRefs: null,
      onUpdateScript: () => {},
      onUpdateScriptCursor: () => {},
    }),
  ];
  view.dispatch({ effects });
}
